<template>
  <header class="header">
    <a href="./" target="_blank" class="logo" v-if="storeInExt"></a>
    <a href="./" class="logo" v-else></a>
    <div class="setting-wrap">
      <a href="#" class="setting-btn saved-btn" :class="{active: savedIsOpen}" @click="toggleSaved">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="main-icon">
          <path d="M18.7499 0H5.24994C4.00728 0 2.99994 1.00734 2.99994 2.25V24L11.9999 18.75L20.9999 24V2.25C20.9999 1.00734 19.9926 0 18.7499 0ZM18.7499 20.0827L11.9999 16.1452L5.24994 20.0827V2.53125C5.24994 2.45666 5.27957 2.38512 5.33232 2.33238C5.38506 2.27963 5.4566 2.25 5.53119 2.25H18.4687C18.624 2.25 18.7499 2.37577 18.7499 2.53106V20.0827Z" fill="#00C6A2"/>
        </svg>
        <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hover-icon">
          <path d="M15.75 0H2.25C1.00734 0 0 1.00734 0 2.25V24L9 18.75L18 24V2.25C18 1.00734 16.9927 0 15.75 0Z" fill="#00C6A2"/>
        </svg>
        <span class="lg-only">Favorites</span>
      </a>
      <a href="#" class="setting-btn gear-btn" :class="{active: settingsOpen}" @click.prevent="settingsToggle">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.68601 3.00001L10.293 0.393006C10.4805 0.205535 10.7348 0.10022 11 0.10022C11.2652 0.10022 11.5195 0.205535 11.707 0.393006L14.314 3.00001H18C18.2652 3.00001 18.5196 3.10536 18.7071 3.2929C18.8946 3.48044 19 3.73479 19 4.00001V7.68601L21.607 10.293C21.7945 10.4805 21.8998 10.7348 21.8998 11C21.8998 11.2652 21.7945 11.5195 21.607 11.707L19 14.314V18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19H14.314L11.707 21.607C11.5195 21.7945 11.2652 21.8998 11 21.8998C10.7348 21.8998 10.4805 21.7945 10.293 21.607L7.68601 19H4.00001C3.73479 19 3.48044 18.8946 3.2929 18.7071C3.10536 18.5196 3.00001 18.2652 3.00001 18V14.314L0.393006 11.707C0.205535 11.5195 0.10022 11.2652 0.10022 11C0.10022 10.7348 0.205535 10.4805 0.393006 10.293L3.00001 7.68601V4.00001C3.00001 3.73479 3.10536 3.48044 3.2929 3.2929C3.48044 3.10536 3.73479 3.00001 4.00001 3.00001H7.68601ZM11 14C11.7957 14 12.5587 13.6839 13.1213 13.1213C13.6839 12.5587 14 11.7957 14 11C14 10.2044 13.6839 9.44129 13.1213 8.87868C12.5587 8.31608 11.7957 8.00001 11 8.00001C10.2044 8.00001 9.44129 8.31608 8.87868 8.87868C8.31608 9.44129 8.00001 10.2044 8.00001 11C8.00001 11.7957 8.31608 12.5587 8.87868 13.1213C9.44129 13.6839 10.2044 14 11 14Z" fill="white"/>
        </svg>
        <span class="lg-only">Settings</span>
      </a>
    </div>
  </header>
</template>

<script>
import {reportEvent} from "../utils";
export default {
  name: 'Header',
  props: ['settingsOpen', 'savedIsOpen', 'storeInExt'],
  methods: {
    toggleSaved () {
      this.$emit('togglesaved');
    },
    settingsToggle() {
      if (!this.settingsOpen) {
        reportEvent('settings', {
          action: 'show'
        })
      }
      this.$emit('settingstoggle', !this.settingsOpen);
    }
  },
}
</script>
